import { render, staticRenderFns } from "./_remapTeam.vue?vue&type=template&id=454e63b6&scoped=true&lang=pug&"
import script from "./_remapTeam.vue?vue&type=script&lang=js&"
export * from "./_remapTeam.vue?vue&type=script&lang=js&"
import style0 from "./_remapTeam.vue?vue&type=style&index=0&id=454e63b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e63b6",
  null
  
)

export default component.exports